export default __webpack_public_path__ + "static/tab8Img-d683cccc3bce2abbe1dffd52f3b82722.png";